<lib-dialog
  #addressWarning="dialog"
  header="We are unable to verify your address as entered"
  yesText="Use this address provided"
  noText="Edit Address"
>
  <ng-template let-clickClose>
    @if (correctedAddress) {
      <div>
        Please make a selection of the address that you provider or the
        recommended USPS verified address. If you'd prefer to edit your address,
        you can do so after the selection is made.
      </div>
    }
    @if (correctedAddress) {
      <div fxLayoutAlign="space-between">
        <div fxLayout="column" fxLayoutGap="10px">
          <read-only-address [address]="inputAddress" [hideStatus]="true">
            <div class="semi-bold">Use the address I provided</div>
          </read-only-address>
          <button
            color="primary"
            mat-flat-button
            (click)="onUseAddress(clickClose, null)"
          >
            Use this address
          </button>
        </div>
        <div fxLayout="column" fxLayoutGap="10px">
          <read-only-address [address]="correctedAddress" [hideStatus]="true">
            <div class="semi-bold">Recommended address:</div>
          </read-only-address>
          <button
            color="primary"
            mat-flat-button
            (click)="onUseAddress(clickClose, correctedAddress)"
          >
            Use Recommended Address
          </button>
        </div>
      </div>
    }
    @if (!correctedAddress) {
      <div>
        We were unable to verify the address due to the following issue:
      </div>
    }
    @if (!correctedAddress) {
      <div>
        <div class="semi-bold" fxLayout="row" fxLayoutGap="10px">
          <mat-icon color="accent">warning</mat-icon
          >{{ validationResultMessage }}
        </div>
      </div>
    }
  </ng-template>
</lib-dialog>
